package navigation.settings.general

import cafe.adriel.voyager.core.model.StateScreenModel
import cafe.adriel.voyager.core.model.screenModelScope
import com.essntl.core.settings.domain.repository.ConfigurationRepository
import com.essntl.core.utils.utils.loadingmanager.LoadingManager

class GeneralScreenModel(
    configurationRepository: ConfigurationRepository,
    loadingManager: LoadingManager,
) : StateScreenModel<GeneralState>(GeneralState()) {

    private val vm =
        GeneralViewModel(
            configurationRepository = configurationRepository,
            state = mutableState,
            scope = screenModelScope,
            loadingManager = loadingManager,
        )

    fun onEvent(event: GeneralEvent) = vm.onEvent(event)
}